// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ap","header":"aq","title":"ar","subHeader":"as"};